import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = boolean;

export const useDefaultObservableBoolean = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectBoolean extends BehaviorSubject<CurrentType> {}
